// Service-area city list (HQ first, then alphabetical-ish by region cluster).

export const SERVICE_CITIES = [
    { name: "Brampton", region: "Peel" },
    { name: "Mississauga", region: "Peel" },
    { name: "Caledon", region: "Peel" },
    { name: "Bolton", region: "Peel" },

    { name: "Toronto", region: "Toronto" },
    { name: "North York", hq: true, region: "Toronto" },
    { name: "Etobicoke", region: "Toronto" },
    { name: "Scarborough", region: "Toronto" },

    { name: "Vaughan", region: "York" },
    { name: "Richmond Hill", region: "York" },
    { name: "Markham", region: "York" },
    { name: "Aurora", region: "York" },
    { name: "Newmarket", region: "York" },

    { name: "Oakville", region: "Halton" },
    { name: "Burlington", region: "Halton" },
    { name: "Milton", region: "Halton" },
    { name: "Halton Hills", region: "Halton" },
    { name: "Georgetown", region: "Halton" },

    { name: "Hamilton", region: "Hamilton" },
    { name: "Stoney Creek", region: "Hamilton" },
    { name: "Ancaster", region: "Hamilton" },
    { name: "Dundas", region: "Hamilton" },

    { name: "Oshawa", region: "Durham" },
];
